"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.System = exports.Manager = exports.Component = void 0;
var Component_1 = require("./Component");
Object.defineProperty(exports, "Component", { enumerable: true, get: function () { return Component_1.Component; } });
var Manager_1 = require("./Manager");
Object.defineProperty(exports, "Manager", { enumerable: true, get: function () { return Manager_1.Manager; } });
var System_1 = require("./System");
Object.defineProperty(exports, "System", { enumerable: true, get: function () { return System_1.System; } });
